import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { ComponentType } from '@/configuration/component/component-types'

export type EditNextReportDatePayload = {
    componentSid: string,
    reportType: number,
    reportId: string,
    date: string
}

export const useEditNextReportDateMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: EditNextReportDatePayload) => 
            hcaClientFactory.componentStatusApi.editNextReportDate(payload.componentSid, payload.reportType, payload.reportId, payload.date),
        onSuccess: async (response, payload) => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ['componentStatus', payload.componentSid, ComponentType.Transformer] }),
                queryClient.invalidateQueries({ queryKey: ['componentStatus', payload.componentSid, ComponentType.Generator] }),
            ])
        },
    })
}
